module.exports = __webpack_public_path__ + "static/035.thumb-f6189a93826e14d860f1c2b1d7874dd8.jpg";